import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { GlobalConstants } from 'src/app/pages/common/global-variables';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  current_year = new Date().getFullYear();

  constructor(public GlobalConstants: GlobalConstants, @Inject(LOCALE_ID) public locale: string) { }

  ngOnInit() {
  }

}
